import { useMutation, useQuery } from "@tanstack/react-query";

import apiClient from "@app/common/api/apiClient";
import useAuth from "@app/common/auth/useAuth";
import ROUTES from "@app/common/routes";
import { getAppUrl, isReadUserEmail } from "@app/utils/utils";

const useReadAdmin = () => {
  const { user, fetchAndSetUser, setImpersonating } = useAuth();

  const impersonatePermissionQuery = useQuery({
    queryKey: ["admin", "impersonatePermission"],
    queryFn: apiClient.admin.getImpersonatePermission,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    enabled: isReadUserEmail(user?.email),
  });

  const handleSuccess = async () => {
    setImpersonating(true);
    await fetchAndSetUser();
    window.location.href = getAppUrl(ROUTES.LANDING_PAGE);
    return impersonatePermissionQuery.refetch();
  };

  const startImpersonationMutation = useMutation({
    mutationFn: apiClient.admin.postImpersonate,
    onSuccess: () => {
      setTimeout(handleSuccess, 1000);
    },
  });

  return {
    isAdmin: impersonatePermissionQuery.data ?? false,
    startImpersonation: startImpersonationMutation,
  };
};

export default useReadAdmin;
